import axiosInstance from "../Axios/AxiosConfig";
import URLS from "../Axios/URLS";


export function getStipePublicKey() {
    return axiosInstance.get(URLS.stripPublicKey).then(response => response.data?.data?.publicKey)
}